<template>
  <b-container>
    <h1 v-translate>B2B API Doc Update Generator</h1>
    <hr>
    <b-row>
      <b-col cols="12">
        <b-textarea v-model="updatedDoc" rows="25" />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

export default {
  name: 'b2bDocUpdate',
  data() {
    return {
      updatedDoc: ''
    }
  },
  mounted() {
    this.updateDoc()
  },
  methods: {
    updateDoc() {
      this.$http.get('https://api-dev.moova.io/docs/api-docs.json')
        .then(response => {
          let coreJson = response.body

          // collect b2b paths
          const paths = Object.keys(coreJson.paths)
            .filter(key => key.indexOf('b2b') !== -1)
            .reduce((obj, key) => {
              obj[key] = coreJson.paths[key]
              return obj
            }, {})

          // collect semi-hardcoded definitions
          const definitions = Object.keys(coreJson.definitions)
            .filter(key => key.indexOf('b2b') !== -1 ||
              key.indexOf('BudgetConfig') !== -1 ||
              key.indexOf('BudgetItem') !== -1 ||
              key.indexOf('ShippingLabel') !== -1 ||
              key.indexOf('ShippingItemCreate') !== -1 ||
              key.indexOf('ApplicationHooks') !== -1 ||
              key.indexOf('CreateB2bShippingFromPlatform') !== -1
            )
            .reduce((obj, key) => {
              obj[key] = coreJson.definitions[key]
              return obj
            }, {})

          // base b2b JSON
          let b2bJson = JSON.parse('{"swagger": "2.0","info": {"title": "Moova.io B2B API","version": "1.0.0","contact": {"email": "api@moova.io"}},"host": "api-dev.moova.io","basePath": "/b2b/","schemes": ["https"],"securityDefinitions": {"appId": {"type": "apiKey","in": "query","name": "appId"},"secretKey": {"type": "apiKey","in": "header","name": "Authorization"}},"security": [{"secretKey": [],"appId": []}]}')

          // inject paths
          b2bJson['paths'] = paths
          // fix some endpoints descriptions to be more clear
          b2bJson['paths']['/b2b/budgets']['post']['summary'] = 'Get the budgets for a Shipping using Google Place IDs'
          b2bJson['paths']['/b2b/v1/budgets']['post']['summary'] = 'Get the budgets for a Shipping using addresses\' strings'
          b2bJson['paths']['/b2b/v2/budgets']['post']['summary'] = 'Get the budgets for a Shipping using addresses\' parts'

          // inject definitions
          b2bJson['definitions'] = definitions

          this.updatedDoc = JSON.stringify(b2bJson)
            // cleanup
            .replace(/\/b2b\//g, '/')
            .replace(/{"name":"appId","in":"query","description":"Applicaction ID","required":true,"type":"string"},/g, '')
            .replace(/,"security":\[{"oauth2_security":\[]}]/g, '')
            .replace(/,"type":"json"/g, '')
            .replace(/"required":\[],/g, '')
            .replace(/"type":"date"/g, '"type":"string"')
            .replace(/"type":"decimal"/g, '"type":"number"')
            .replace(/"basePath":"\/"/g, '"basePath":"/b2b/"')
        })
    }
  }
}

</script>
